"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transitionClientCohortSchema = exports.updateClientSchema = exports.createClientSchema = exports.clientSchema = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.clientSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    firstName: zod_1.z.string().min(1),
    lastName: zod_1.z.string().min(1),
    externalRef: zod_1.z.string().nullable().optional(),
    cohort: zod_1.z.enum(enums_js_1.CohortLetters),
    cohortNumber: zod_1.z.number().int().positive(),
    cohortId: zod_1.z.string(),
    status: zod_1.z.enum(enums_js_1.ClientStatuses),
    telehealthAllowed: zod_1.z.boolean(),
    homeCommunityOk: zod_1.z.boolean(),
    transportLimited: zod_1.z.boolean(),
    preferredDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)),
    iopTrackResourceId: zod_1.z.string().uuid().nullable().optional(),
    iopTrackName: zod_1.z.string().nullable().optional(),
    nursingGroupDay: zod_1.z.enum(enums_js_1.DayOfWeeks).nullable().optional(),
    nursingSkip: zod_1.z.boolean().optional(),
    intakeDate: localDate_js_1.localDateSchema,
    dischargedDate: localDate_js_1.localDateSchema.nullable().optional(),
    caseManagerResourceId: zod_1.z.string().uuid().nullable().optional(),
    caseManagerName: zod_1.z.string().nullable().optional(),
    notes: zod_1.z.string().nullable().optional(),
    requiredServices: zod_1.z.array(zod_1.z.enum(enums_js_1.IndividualServiceTypes)),
});
exports.createClientSchema = zod_1.z.object({
    firstName: zod_1.z.string().min(1).max(200).trim(),
    lastName: zod_1.z.string().min(1).max(200).trim(),
    externalRef: zod_1.z.string().nullable().optional(),
    cohort: zod_1.z.enum(enums_js_1.CohortLetters),
    telehealthAllowed: zod_1.z.boolean().default(true),
    homeCommunityOk: zod_1.z.boolean().default(true),
    transportLimited: zod_1.z.boolean().default(false),
    preferredDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)).default([]),
    iopTrackResourceId: zod_1.z.string().uuid().nullable().optional(),
    nursingGroupDay: zod_1.z.enum(enums_js_1.DayOfWeeks).nullable().optional(),
    nursingSkip: zod_1.z.boolean().optional(),
    intakeDate: localDate_js_1.localDateSchema.optional(),
    caseManagerResourceId: zod_1.z.string().uuid().nullable().optional(),
    locationId: zod_1.z.string().uuid().nullable().optional(),
    notes: zod_1.z.string().max(2000).nullable().optional(),
    requiredServices: zod_1.z.array(zod_1.z.enum(enums_js_1.IndividualServiceTypes)).optional(),
});
exports.updateClientSchema = exports.createClientSchema.partial().extend({
    status: zod_1.z.enum(enums_js_1.ClientStatuses).optional(),
    dischargedDate: localDate_js_1.localDateSchema.optional(),
});
// Step-up / step-down between programs. The controller and the
// ClientCohortsService share this shape; keeping it Zod-validated
// prevents an operator from POSTing e.g. a string instead of an array
// for requiredServices and crashing inside the SERIALIZABLE transaction.
exports.transitionClientCohortSchema = zod_1.z.object({
    newCohort: zod_1.z.enum(enums_js_1.CohortLetters),
    transitionDate: localDate_js_1.localDateSchema.optional(),
    reason: zod_1.z.string().max(500).optional(),
    iopTrackResourceId: zod_1.z.string().uuid().nullable().optional(),
    requiredServices: zod_1.z.array(zod_1.z.enum(enums_js_1.IndividualServiceTypes)).optional(),
});
//# sourceMappingURL=client.js.map